import { useState } from 'react';
import { signInWithGoogle } from '../lib/api.js';
import Icon from '../components/Icon.jsx';

export default function SignIn() {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  const go = async (fn) => {
    setBusy(true); setError(null);
    try { await fn(); } catch (e) { setError(e.message); } finally { setBusy(false); }
  };

  return (
    <div className="signin">
      <div className="signin-card">
        <img className="logo" src="/icon.svg" alt="" />
        <h1>I nostri viaggi</h1>
        <p>Itinerari, prenotazioni e documenti. Solo per chi è invitato al viaggio.</p>

        <button className="btn" disabled={busy} onClick={() => go(signInWithGoogle)}>
          <Icon name="google" size={17} />
          Entra con Google
        </button>

        <p style={{ margin: 'var(--s-5) 0 0', fontSize: 'var(--t-xs)', color: 'var(--faint)' }}>
          L'accesso è su invito. Se il tuo indirizzo non è fra quelli autorizzati,
          Google non ti farà entrare.
        </p>

        {error && <p className="error" style={{ marginTop: 'var(--s-4)' }}>{error}</p>}
      </div>
    </div>
  );
}
